import { render, staticRenderFns } from "./VideoCallButton.vue?vue&type=template&id=fc55627a&"
import script from "./VideoCallButton.vue?vue&type=script&lang=js&"
export * from "./VideoCallButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc55627a')) {
      api.createRecord('fc55627a', component.options)
    } else {
      api.reload('fc55627a', component.options)
    }
    module.hot.accept("./VideoCallButton.vue?vue&type=template&id=fc55627a&", function () {
      api.rerender('fc55627a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/VideoCallButton.vue"
export default component.exports